import React, { Component } from "react";
import "../../Styles/Admin.scss";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

import userConfig from './UserAccess.json'
import { TreeView } from '@progress/kendo-react-treeview';


const tree = [{
  text: 'HS2', expanded: false, items: [
      { text: 'New Trains' }, { text: 'Stations' }]
}];


class UserAccess extends Component {

  render() {
    return (
      <div className="UserAccessCont userAccess">
          <div className="userConfig">
            <h4>Define User Configuration</h4>
            <div className="ucBox">
              <div className=" tblCont dataGrids ">
                <div className="rw-tab-content">
                  <Grid data={[...userConfig]}>
                    <Column  title="User" 
                    width="400"
                       cell = {props => (
                        <td>
                          <div className="userFlexBox">
                            <input type="text" placeholder="New User"/>
                            <span>Or</span>
                            <select>
                              <option>Select User</option>
                              <option>Arash</option>
                              <option>Patric</option>
                            </select> 
                          </div>
                        </td>
                      )}
                    />
                    <Column  
                      title="select user type" 
                      cell = {props => (
                        <td>
                          <select>
                            <option>Select User Type</option>
                            <option>Super Admin</option>
                            <option>Standard User</option>
                          </select>
                        </td>
                      )}
                    />
                    <Column  title="Select Workstream" 
                      cell = {props => (
                        <td>
                         <TreeView
                            data={tree}
                            checkboxes={true}
                            expandIcons={true}
                            onExpandChange={this.onExpandChange}
                            onItemClick={this.onItemClick}
                            aria-multiselectable={true}
                        />

                        </td>
                      )}
                    />
                    <Column title="" 
                    cell = {props => (
                      <td><button class="svBtn">Save</button></td>
                    )}
                    />

                  
                  </Grid>
                </div>
              </div>
            </div>
          </div>

      </div>
    )
  }

  onItemClick = (event) => {
    event.item.selected = !event.item.selected;
    this.forceUpdate();
}
onExpandChange = (event) => {
    event.item.expanded = !event.item.expanded;
    this.forceUpdate();
}


}
export default UserAccess
